let loadedId = '';

export function initAnalytics() {
  const id = process.env.VUE_APP_GA_MEASUREMENT_ID;
  if (!id || loadedId === id || typeof window === 'undefined') return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', id, { send_page_view: false });
  loadedId = id;
}

export function trackPageView(route) {
  const id = process.env.VUE_APP_GA_MEASUREMENT_ID;
  if (!id || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_title: document.title || 'Educ360',
    page_location: window.location.href,
    page_path: route && route.fullPath ? route.fullPath : window.location.pathname,
  });
}

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', name, params);
}
